
<div class="header-toolbar">
  <h1>
    Utilisateurs clients

    <span class="tag" *ngIf="filter.search">
      <span class="text">Recherche: {{ filter.search }}</span>
      <t-icon name="close" title="Supprimer ce filtre" (click)="clearSearch()"></t-icon>
    </span>
  </h1>
</div>

<!-- Toolbar -->
<div class="main btn-toolbar">

  <div class="btn-group">    
    <div class="content">
      
      <a class="btn" [routerLink]="'/shares-ledger/client-users/new'">
        <t-icon name="add"></t-icon>
        <span class="text">Ajouter</span>
      </a>
      <button class="btn" (click)="applyFilter()">
        <t-icon name="search"></t-icon>
        <span class="text">Filtrer</span>
      </button>

    </div>
  </div>

  <div class="btn-group">    
    <div class="content">
      
      <a class="btn" [routerLink]="'deleted'">
        <t-icon name="folder"></t-icon>
        <span class="text">Supprimés</span>
      </a>

    </div>
  </div>

</div>
<!-- /Toolbar -->

<table>

  <thead>
    <tr>
      <th style="width: 20px;"></th>
      <th>Nom d'utilisateur</th>
      <th>Prènom</th>
      <th>Nom</th>
      <th>Date d'ajout</th>
      <th>Fuseau horaire</th>
      <th>Role</th>
      <th>Compte client</th>
      <th style="width: 100px;"></th>
    </tr>
  </thead>

  <tbody *ngIf="users && users.length > 0">
    <tr *ngFor="let user of users" (click)="showCLUser(user, $event)">
      <td class="icon-labels">
        <span *ngIf="user.emailVerified" title="Adresse e-mail vérifiée">
          <t-icon name="check_circle_outline"></t-icon>
        </span>
        <span *ngIf="!user.emailVerified" title="Adresse e-mail non vérifiée">
          <t-icon name="warning"></t-icon>
        </span>
      </td>
      <td name="Nom d'utilisateur">
        {{ user.username }}
      </td>
      <td name="Prènom">{{ user.firstname }}</td>
      <td name="Nom">{{ user.lastname }}</td>
      <td name="Date d'ajout">{{ user.createdAt | tzdate:'short' }}</td>
      <td name="Fuseau horaire">{{ user.timezone }}</td>
      <td name="Role">{{ user.role | cluserrole }}</td>
      <td name="Compte client">{{ user.account.name }}</td>
      <td style="width: 100px;" class="actions">
        <a class="action-btn" title="Modifer" [routerLink]="[user.id, 'edit']">
          <t-icon name="mode_edit"></t-icon>
        </a>
        <a class="action-btn" title="Supprimer" (click)="delete(user)">
          <t-icon name="delete"></t-icon>
        </a>
      </td>
    </tr>
  </tbody>

  <tbody *ngIf="!users || users.length == 0">
    <tr>
      <td class="text-center" colspan="9">
        <ng-container *ngIf="users && users.length == 0">
          Aucun utilisateur n'a été trouvé
        </ng-container>
        <ng-container *ngIf="!users">
          Chargement...
        </ng-container>
      </td>
    </tr>
  </tbody>

</table>

<div class="pagination" *ngIf="users">
  <button class="btn btn-gray" (click)="fetchMore()" *ngIf="users.length < usersCount">
    <t-icon name="arrow_downward"></t-icon>
    <span class="text">Afficher plus</span>
  </button>
  <div class="page-number">
    {{ users.length }} / {{ usersCount }}
  </div>
</div>